module.exports = __webpack_public_path__ + "static/media/YoYo_Icon_Shadow@2x.804d2819.png";